import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import CreateVendorForm from 'src/components/_dashboard/vendor/CreateVendorForm';
import VendorList from '../../components/_dashboard/vendor/VendorList';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getVendorList, getAllModuleList } from '../../redux/slices/vendor';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function Vendor() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { vendorList, disableVendorList, isLoading, moduleList } = useSelector((state) => state.vendor);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentVendor, setCurrentVendor] = useState({});
  const [vendorListStatus, setVendorListStatus] = useState(true);

  useEffect(() => {
    dispatch(getVendorList(true));
    dispatch(getVendorList(false));
    dispatch(getAllModuleList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getVendorList(vendorListStatus));
  }, [vendorListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempVendor = vendorList.find((vendor) => vendor.id === editId);
      setCurrentVendor(tempVendor);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };

  return (
    <Page title="Vendor | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Vendor"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Vendor',
              href: PATH_DASHBOARD.general.vendor,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Vendor` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Add Vendor
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && (
          <CreateVendorForm moduleList={moduleList} setVisibleComponent={setVisibleComponent} />
        )}
        {visibleComponent === 'List' && (
          <VendorList
            vendorList={vendorListStatus ? vendorList : disableVendorList}
            setEditId={setEditId}
            vendorListStatus={vendorListStatus}
            setVendorListStatus={setVendorListStatus}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <CreateVendorForm
            moduleList={moduleList}
            editId={editId}
            currentVendor={currentVendor}
            setVisibleComponent={setVisibleComponent}
          />
        )}
      </Container>
    </Page>
  );
}
